import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';

import listenerMiddleware from './middlewares';
import { appStateReducer, authReducer } from './slices';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    appState: appStateReducer,
  },
  // TODO investigate
  // eslint-disable-next-line
  // @ts-ignore
  middleware: (getDefaultMiddleware) => {
    const middlewares = getDefaultMiddleware().prepend(listenerMiddleware);

    if (process.env.NODE_ENV === 'development') {
      const logger = createLogger({
        collapsed: true,
      });

      return middlewares.concat(logger);
    }

    return middlewares;
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
